import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, Tooltip, Typography } from '@mui/material';
import ProductListContainer from './ProductListContainer';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export default function ProductExpandCollapseHeading({heading, expanded, setExpanded, status,overallstatusid}) {
    const handleClick = ()=>{
        setExpanded(!expanded)
    }
    const getOverallStatusText = (overallstatusid) => {
        switch (overallstatusid) {
            case 0:
                return 'DRAFT';
            case 1:
            return 'APPROVAL';     
            case 2:
                return 'PRODUCTION';
            
            case 8:
                return 'ARCHIVED'; 
            case 9:
                return 'ON HOLD';
            case 10:
                return 'CANCELLED';
            
            
        }
    }
    return (

        <Grid
            container
            direction="row"
            sx={{
            justifyContent: "space-between",
            alignItems: "flex-start",
            cursor: "pointer",
            
            }}
            padding={1}
            //spacing={1}
            onClick={handleClick}
        >
            <Grid item lg={8} >
                <Typography variant='h4' color="primary.700">{heading}</Typography>
            </Grid>
            <Grid item lg={2} >
                <Typography variant='h6' sx={{ color: 'primary.main' }}>{getOverallStatusText(overallstatusid)}</Typography>
            </Grid>
            <Grid item lg={2} >
                <Box
                    sx={{
                        backgroundColor: 'primary.darker',
                        borderRadius: 3,
                        px: 2,
                        py: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '1px solid #e0e0e0',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}
                >
                    
                    <Typography variant='h6' sx={{ color: 'white' }}>{status}</Typography>
                </Box>
            </Grid>
            {/* <Grid item lg={1} >
                <Grid
                    container
                    direction="row"
                    sx={{
                    justifyContent: "flex-end",
                    alignItems: "center",
                    
                }}>
                    {expanded?
                        <Tooltip title="Collapse" sx={{cursor: "pointer"}}>
                            <ExpandLessIcon onClick={()=>setExpanded(false)}/>
                        </Tooltip>
                    :
                        <Tooltip title="Expand" sx={{cursor: "pointer"}}>
                            <ExpandMoreIcon onClick={()=>setExpanded(true)}/>
                        </Tooltip>
                    }
                </Grid>
            </Grid> */}
            
            
        </Grid>
            

    )
}